import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { Form } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { Input, Alert, Button } from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';

const EditPhrasePage = (props) => {
  const { t, isSubmitting, getPhraseError, phrase = {} } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onEditPhrase(values);
    }
  }
  if (Object.keys(getPhraseError).length) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This phrase is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  function getTitle() {
    return `Edit Phrase: ${phrase.phrase || ''}`;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <div className="row">
          <div className="col">
            <Formik
              enableReinitialize
              initialValues={phrase}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({ values, handleChange, errors, touched, handleSubmit }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onEditPhrase(values);
                      }}
                    />
                    <Input
                      required
                      label="Phrase"
                      id="phrase"
                      onChange={handleChange('phrase')}
                      invalid={errors.phrase && touched.phrase}
                      value={values.phrase}
                      error={errors.phrase}
                    />
                    <Alert.Error text={props.errors} />
                    <Button
                      id="create-phrase"
                      loading={isSubmitting}
                      onClick={handleSubmit}
                    >
                      <i className="md-icon">done</i>
                      {t('Save')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="col" />
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(EditPhrasePage);
